export default __webpack_public_path__ + "static/IP_Vision_Pro_09-18eabc4c549161349d491484b98d27f0.webp";